<app-side-menu>
  <div class="b2b-contracts-item-form-container">
    <app-loading [show]="isLoading && isEditMode" message="Carregando pedido..."></app-loading>

    <!-- Header -->
    <div class="header" *ngIf="!(isLoading && isEditMode)">
      <div class="title-section">
        <button type="button" class="btn-back" (click)="navigateBack()">
          <i class="fas fa-arrow-left"></i>
        </button>
        <div class="title-info">
          <h1>
            <i class="fas me-2" [ngClass]="isEditMode ? 'fa-edit' : 'fa-plus-circle'"></i>
            {{ isEditMode ? 'Editar Pedido do Contrato' : 'Novo Pedido do Contrato' }}
          </h1>
          <p *ngIf="contractNumber">Contrato: {{ contractNumber }} — {{ contractName }}</p>
          <p *ngIf="isEditMode && loadedItemNumber" class="text-muted small mb-0">
            Pedido: <strong>{{ loadedItemNumber }}</strong>
          </p>
        </div>
      </div>
      <div class="action-buttons">
        <button type="button" class="btn btn-secondary" (click)="navigateBack()">
          <i class="fas fa-arrow-left me-2"></i>
          Cancelar
        </button>
      </div>
    </div>

    <form *ngIf="!(isLoading && isEditMode)" [formGroup]="itemForm" (ngSubmit)="onSubmit()">
      <div class="steps-indicator mb-4">
        <div class="step" [class.active]="currentStep === 1">
          <span class="step-number">1</span>
          <span class="step-title">Dados do Pedido</span>
        </div>
        <div class="step" [class.active]="currentStep === 2">
          <span class="step-number">2</span>
          <span class="step-title">Pagamento</span>
        </div>
      </div>

      <div *ngIf="currentStep === 1">
      <!-- Informações do Pedido -->
      <div class="card mb-4">
        <div class="card-header text-white">
          <h3 class="mb-0">
            <i class="fas fa-info-circle me-2"></i>
            Informações do Pedido
          </h3>
        </div>
        <div class="card-body">
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label">Tipo de Moto <span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                formControlName="motorcycleType"
                [class.is-invalid]="isFieldInvalid('motorcycleType')"
                placeholder="Ex: Yamaha Factor 150">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('motorcycleType')">
                {{ getFieldError('motorcycleType') }}
              </div>
            </div>
            <div class="col-md-6">
              <label class="form-label">Quantidade de Veículos <span class="text-danger">*</span></label>
              <input
                type="number"
                class="form-control"
                formControlName="vehicleQuantity"
                [class.is-invalid]="isFieldInvalid('vehicleQuantity')"
                min="1"
                (input)="onVehicleQuantityChange()"
                (change)="onVehicleQuantityChange()">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('vehicleQuantity')">
                {{ getFieldError('vehicleQuantity') }}
              </div>
              <small class="form-text text-muted">Quantos veículos serão cadastrados neste lote</small>
            </div>
            <div class="col-md-4">
              <label class="form-label">Valor Unitário <span class="text-danger">*</span></label>
              <app-sensitive-currency
                formControlName="unitValue"
                [invalid]="isFieldInvalid('unitValue')"
                [min]="0"
                step="0.01">
              </app-sensitive-currency>
              <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('unitValue')">
                {{ getFieldError('unitValue') }}
              </div>
            </div>
            <div class="col-md-4">
              <label class="form-label">Status <span class="text-danger">*</span></label>
              <select
                class="form-select"
                formControlName="status"
                [class.is-invalid]="isFieldInvalid('status')">
                <option *ngFor="let status of statusOptions" [value]="status.value">{{ status.label }}</option>
              </select>
              <div class="invalid-feedback" *ngIf="isFieldInvalid('status')">
                {{ getFieldError('status') }}
              </div>
            </div>
            <div class="col-md-6">
              <label class="form-label">Metodo de Pagamento <span class="text-danger">*</span></label>
              <select
                class="form-select"
                formControlName="paymentType"
                [class.is-invalid]="isFieldInvalid('paymentType')">
                <option *ngFor="let method of paymentMethods" [value]="method.value">{{ method.label }}</option>
              </select>
              <div class="invalid-feedback" *ngIf="isFieldInvalid('paymentType')">
                {{ getFieldError('paymentType') }}
              </div>
            </div>
            <div class="col-md-6">
              <label class="form-label">Número de Parcelas <span class="text-danger">*</span></label>
              <input
                type="number"
                class="form-control"
                formControlName="installmentCount"
                [class.is-invalid]="isFieldInvalid('installmentCount')"
                min="1"
                max="24">
              <small class="form-text text-muted">Quantidade de parcelas em Contas a Receber por veículo (valor de cada uma = valor unitário).</small>
              <div class="invalid-feedback" *ngIf="isFieldInvalid('installmentCount')">
                {{ getFieldError('installmentCount') }}
              </div>
            </div>
            <div class="col-md-6">
              <label class="form-label">Tipo de Contrato <span class="text-danger">*</span></label>
              <select
                class="form-select"
                formControlName="contractType"
                [class.is-invalid]="isFieldInvalid('contractType')">
                <option *ngFor="let type of contractTypeOptions" [value]="type">{{ type }}</option>
              </select>
              <div class="invalid-feedback" *ngIf="isFieldInvalid('contractType')">
                {{ getFieldError('contractType') }}
              </div>
            </div>
            <div class="col-md-6">
              <label class="form-label">Tipo de Entrega <span class="text-danger">*</span></label>
              <select
                class="form-select"
                formControlName="deliveryType"
                [class.is-invalid]="isFieldInvalid('deliveryType')">
                <option *ngFor="let type of deliveryTypeOptions" [value]="type">{{ type }}</option>
              </select>
              <div class="invalid-feedback" *ngIf="isFieldInvalid('deliveryType')">
                {{ getFieldError('deliveryType') }}
              </div>
            </div>

            <div class="col-12">
              <div class="alert alert-light border py-2 small mb-0">
                <i class="fas fa-map-marker-alt me-1 text-primary"></i>
                Controle de localização do pedido (UF / cidade / endereço) — ajuda a equipe a acompanhar onde o veículo/pedido está.
                <span *ngIf="isEntregaDelivery"> Campos obrigatórios para entrega no local do cliente.</span>
              </div>
            </div>
            <div class="col-md-4">
              <label class="form-label">
                Estado (UF)
                <span class="text-danger" *ngIf="isEntregaDelivery">*</span>
              </label>
              <select
                class="form-select"
                formControlName="state"
                [class.is-invalid]="isFieldInvalid('state')">
                <option value="">Selecione</option>
                <option *ngFor="let uf of brazilianStates" [value]="uf">{{ uf }}</option>
              </select>
              <div class="invalid-feedback" *ngIf="isFieldInvalid('state')">
                {{ getFieldError('state') }}
              </div>
            </div>
            <div class="col-md-4">
              <label class="form-label">
                Cidade
                <span class="text-danger" *ngIf="isEntregaDelivery">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                formControlName="city"
                [class.is-invalid]="isFieldInvalid('city')"
                placeholder="Ex: São Paulo">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('city')">
                {{ getFieldError('city') }}
              </div>
            </div>
            <div class="col-md-4">
              <label class="form-label">
                Rua / número
                <span class="text-danger" *ngIf="isEntregaDelivery">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                formControlName="pole"
                [class.is-invalid]="isFieldInvalid('pole')"
                placeholder="Ex: Av. Paulista, 1000">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('pole')">
                {{ getFieldError('pole') }}
              </div>
            </div>
            <div class="col-md-6">
              <label class="form-label">Data de Entrega <span class="text-danger">*</span></label>
              <input
                type="date"
                class="form-control"
                formControlName="deliveryDate"
                [class.is-invalid]="isFieldInvalid('deliveryDate')">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('deliveryDate')">
                {{ getFieldError('deliveryDate') }}
              </div>
            </div>
            <div class="col-md-6">
              <label class="form-label">Data de Devolução</label>
              <input
                type="date"
                class="form-control"
                formControlName="returnDate">
            </div>
            <div class="col-md-6">
              <label class="form-label">Data de Retirada (cliente)</label>
              <input
                type="date"
                class="form-control"
                formControlName="customerPickupDate">
            </div>
            <div class="col-12">
              <label class="form-label">{{ isEditMode ? 'Descrição de Acessórios' : 'Descrição' }}</label>
              <textarea
                class="form-control"
                formControlName="accessoriesDescription"
                rows="3"
                [placeholder]="isEditMode ? 'Ex: Baú 45L, GPS, Kit segurança' : 'Informações adicionais do pedido'"></textarea>
            </div>
          </div>
        </div>
      </div>

      <!-- Veículos -->
      <div class="card mb-4" *ngIf="vehicleSnapshots.length > 0">
        <div class="card-header text-white">
          <h3 class="mb-0">
            <i class="fas fa-motorcycle me-2"></i>
            Veículos ({{ vehicleSnapshots.length }})
          </h3>
        </div>
        <div class="card-body">
          <p class="text-muted small mb-3">
            Use o <strong>Status operacional</strong> de cada moto (ATIVO, INATIVO, MANUTENCAO, SINISTRADO) para o controle da equipe.
          </p>
          <div formArrayName="vehicleSnapshots">
            <div *ngFor="let vehicle of vehicleSnapshots.controls; let i = index" class="vehicle-card mb-4">
              <div class="card border">
                <div class="card-header bg-secondary text-white">
                  <h6 class="mb-0"><i class="fas fa-motorcycle me-2"></i> Veículo {{ i + 1 }}</h6>
                </div>
                <div class="card-body">
                  <div [formGroupName]="i" class="row g-3">
                    <div class="col-md-3">
                      <label class="form-label">Placa <span class="text-danger">*</span></label>
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          formControlName="plate"
                          [class.is-invalid]="isVehicleFieldInvalid(i, 'plate')"
                          placeholder="ABC-1234"
                          (keyup.enter)="searchVehicleByPlate(i)">
                        <button
                          type="button"
                          class="btn btn-outline-primary"
                          (click)="searchVehicleByPlate(i)"
                          [disabled]="isSearchingVehicle">
                          <i class="fas" [ngClass]="isSearchingVehicle ? 'fa-spinner fa-spin' : 'fa-search'"></i>
                        </button>
                      </div>
                      <div class="invalid-feedback" *ngIf="isVehicleFieldInvalid(i, 'plate')">
                        {{ getVehicleFieldError(i, 'plate') }}
                      </div>
                      <small class="form-text text-muted">Informe a placa e clique em buscar para preencher os dados do veículo.</small>
                    </div>
                    <div class="col-md-3">
                      <label class="form-label">Marca <span class="text-danger">*</span></label>
                      <input type="text" class="form-control" formControlName="brand"
                        [class.is-invalid]="isVehicleFieldInvalid(i, 'brand')" placeholder="Ex: Yamaha">
                      <div class="invalid-feedback" *ngIf="isVehicleFieldInvalid(i, 'brand')">
                        {{ getVehicleFieldError(i, 'brand') }}
                      </div>
                    </div>
                    <div class="col-md-3">
                      <label class="form-label">Modelo <span class="text-danger">*</span></label>
                      <input type="text" class="form-control" formControlName="model"
                        [class.is-invalid]="isVehicleFieldInvalid(i, 'model')" placeholder="Ex: CG 160">
                      <div class="invalid-feedback" *ngIf="isVehicleFieldInvalid(i, 'model')">
                        {{ getVehicleFieldError(i, 'model') }}
                      </div>
                    </div>
                    <div class="col-md-3">
                      <label class="form-label">Ano <span class="text-danger">*</span></label>
                      <input type="number" class="form-control" formControlName="year"
                        [class.is-invalid]="isVehicleFieldInvalid(i, 'year')" min="1900" [max]="maxYear">
                      <div class="invalid-feedback" *ngIf="isVehicleFieldInvalid(i, 'year')">
                        {{ getVehicleFieldError(i, 'year') }}
                      </div>
                    </div>
                    <div class="col-md-3">
                      <label class="form-label">Cor <span class="text-danger">*</span></label>
                      <input type="text" class="form-control" formControlName="color"
                        [class.is-invalid]="isVehicleFieldInvalid(i, 'color')" placeholder="Ex: Vermelha">
                      <div class="invalid-feedback" *ngIf="isVehicleFieldInvalid(i, 'color')">
                        {{ getVehicleFieldError(i, 'color') }}
                      </div>
                    </div>
                    <div class="col-md-3">
                      <label class="form-label">RENAVAM <span class="text-danger">*</span></label>
                      <input type="text" class="form-control" formControlName="renavam"
                        [class.is-invalid]="isVehicleFieldInvalid(i, 'renavam')" placeholder="12345678901">
                      <div class="invalid-feedback" *ngIf="isVehicleFieldInvalid(i, 'renavam')">
                        {{ getVehicleFieldError(i, 'renavam') }}
                      </div>
                    </div>
                    <div class="col-md-3">
                      <label class="form-label">Chassi <span class="text-danger">*</span></label>
                      <input type="text" class="form-control" formControlName="chassis"
                        [class.is-invalid]="isVehicleFieldInvalid(i, 'chassis')" placeholder="9BD12345678901234">
                      <div class="invalid-feedback" *ngIf="isVehicleFieldInvalid(i, 'chassis')">
                        {{ getVehicleFieldError(i, 'chassis') }}
                      </div>
                    </div>
                    <div class="col-md-3">
                      <label class="form-label">Quilometragem Atual <span class="text-danger">*</span></label>
                      <input type="number" class="form-control" formControlName="currentKm"
                        [class.is-invalid]="isVehicleFieldInvalid(i, 'currentKm')" min="0" placeholder="0">
                      <div class="invalid-feedback" *ngIf="isVehicleFieldInvalid(i, 'currentKm')">
                        {{ getVehicleFieldError(i, 'currentKm') }}
                      </div>
                    </div>
                    <div class="col-md-6">
                      <label class="form-label">Observações da Vistoria</label>
                      <textarea class="form-control" formControlName="inspectionNotes" rows="2"
                        placeholder="Ex: Moto em perfeito estado"></textarea>
                    </div>
                    <div class="col-md-3">
                      <label class="form-label">Tipo de Rastreador</label>
                      <input type="text" class="form-control" formControlName="trackerType" placeholder="Ex: One, Tracksys">
                    </div>
                    <div class="col-md-3">
                      <label class="form-label">ID do Rastreador</label>
                      <input type="text" class="form-control" formControlName="trackerId" placeholder="Ex: TRK-001">
                    </div>
                    <div class="col-md-3">
                      <label class="form-label">Status operacional</label>
                      <select class="form-select" formControlName="operationalStatus">
                        <option value="ATIVO">ATIVO</option>
                        <option value="INATIVO">INATIVO</option>
                        <option value="MANUTENCAO">MANUTENCAO</option>
                        <option value="SINISTRADO">SINISTRADO</option>
                      </select>
                    </div>
                    <div class="col-md-12">
                      <div class="form-check">
                        <input type="checkbox" class="form-check-input" formControlName="hasBox" [id]="'hasBox' + i">
                        <label class="form-check-label" [for]="'hasBox' + i">Possui Baú</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>

      <div *ngIf="currentStep === 2">
        <div class="card mb-4">
          <div class="card-header text-white">
            <h3 class="mb-0">
              <i class="fas fa-dollar-sign me-2"></i>
              Pagamentos e Contas a Receber
            </h3>
          </div>
          <div class="card-body">
            <div class="alert alert-secondary py-2 small mb-3">
              <strong>Resumo:</strong> valor total do pedido
              <app-sensitive-currency class="d-inline-flex align-middle mx-1" [displayOnly]="true" [amount]="getOrderTotal()"></app-sensitive-currency>
              —
              cada veículo terá <strong>{{ getParcelasPorVeiculo() }}</strong> parcela(s) em
              <strong>Contas a Receber</strong> de
              <app-sensitive-currency class="d-inline-flex align-middle mx-1" [displayOnly]="true" [amount]="getValorParcelaPorVeiculo()"></app-sensitive-currency>
              (valor unitário por parcela).
              Os vencimentos são calculados a cada 30 dias.
            </div>

            <div class="row g-3 mb-3">
              <div class="col-md-4">
                <label class="form-label">Valor total do pedido</label>
                <app-sensitive-currency [displayOnly]="true" [amount]="getOrderTotal()"></app-sensitive-currency>
              </div>
              <div class="col-md-4">
                <label class="form-label">Valor da caução (total)</label>
                <app-sensitive-currency
                  formControlName="depositAmount"
                  [min]="0"
                  step="0.01"
                  (valueChange)="onDepositOrFirstTotalChange()">
                </app-sensitive-currency>
              </div>
              <div class="col-md-4">
                <label class="form-label">Valor da 1ª parcela (total)</label>
                <app-sensitive-currency
                  formControlName="firstInstallmentAmount"
                  [min]="0"
                  step="0.01"
                  (valueChange)="onDepositOrFirstTotalChange()">
                </app-sensitive-currency>
              </div>
            </div>

            <div class="installment-preview-panel mb-4">
              <div class="d-flex justify-content-between align-items-center mb-2 flex-wrap gap-2">
                <h5 class="mb-0">Prévia das parcelas (Contas a Receber)</h5>
                <div class="form-check m-0">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="adjustWeekendToPreviousBusinessDay"
                    [checked]="adjustWeekendToPreviousBusinessDay"
                    (change)="onToggleAdjustWeekendToPreviousBusinessDay($any($event.target).checked)">
                  <label class="form-check-label" for="adjustWeekendToPreviousBusinessDay">
                    Se cair em sábado/domingo, jogar para sexta anterior
                  </label>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table table-sm installment-preview-table">
                  <thead>
                    <tr>
                      <th>Placa</th>
                      <th>Parcela</th>
                      <th>Vencimento</th>
                      <th>Valor</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let row of installmentPreviewRows" [class.weekend-row]="row.isWeekend">
                      <td><strong>{{ row.plate }}</strong></td>
                      <td>{{ row.installmentNumber }}/{{ getParcelasPorVeiculo() }}</td>
                      <td>
                        <input
                          type="date"
                          class="form-control form-control-sm"
                          [ngModel]="row.dueDate"
                          (ngModelChange)="onInstallmentDueDateChange(row.overrideKey, $event)"
                          [ngModelOptions]="{ standalone: true }">
                      </td>
                      <td>
                        <app-sensitive-currency [displayOnly]="true" [amount]="row.amount"></app-sensitive-currency>
                      </td>
                      <td>
                        <span *ngIf="isInstallmentWeekend(row.dueDate)" class="weekend-badge">Fim de semana</span>
                        <span *ngIf="!isInstallmentWeekend(row.dueDate)" class="text-success">Dia útil</span>
                      </td>
                    </tr>
                    <tr *ngIf="installmentPreviewRows.length === 0">
                      <td colspan="5" class="text-muted text-center">Sem parcelas para exibir.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <h5 class="mt-2 mb-2">Caução</h5>
            <div class="row g-3 mb-2">
              <div class="col-md-6">
                <label class="form-label">Quantidade de métodos</label>
                <select class="form-select" [(ngModel)]="depositPaymentMode" (ngModelChange)="setDepositPaymentMode($event)" [ngModelOptions]="{ standalone: true }">
                  <option [ngValue]="'single'">1 método</option>
                  <option [ngValue]="'split'">2 métodos</option>
                </select>
              </div>
              <div class="col-md-6" *ngIf="hasDepositBoleto()">
                <label class="form-label">Parcelas do boleto da caução</label>
                <select class="form-select" [(ngModel)]="depositInstallments" [ngModelOptions]="{ standalone: true }">
                  <option [ngValue]="1">À vista (1x)</option>
                  <option *ngFor="let n of [2,3,4,5,6,7,8,9,10]" [ngValue]="n">{{ n }}x</option>
                </select>
                <small class="text-muted">O valor em boleto será dividido em {{ depositInstallments }} parcela(s).</small>
              </div>
            </div>
            <div class="row g-3 mb-2" *ngFor="let p of depositPayments; let i = index" [hidden]="depositPaymentMode === 'single' && i === 1">
              <div class="col-md-6">
                <label class="form-label">Método {{ i + 1 }}</label>
                <select class="form-select" [ngModel]="depositPayments[i].method" (ngModelChange)="onDepositMethodChange(i, $event)" [ngModelOptions]="{ standalone: true }">
                  <option *ngFor="let method of paymentMethods" [value]="method.value">{{ method.label }}</option>
                </select>
              </div>
              <div class="col-md-6">
                <label class="form-label">Valor</label>
                <app-sensitive-currency
                  [ngModel]="depositPayments[i].amount ? depositPayments[i].amount : null"
                  (ngModelChange)="onDepositAmountChange(i, $event)"
                  [ngModelOptions]="{ standalone: true }"
                  [min]="0"
                  step="0.01"
                  [readonly]="depositPaymentMode === 'single'">
                </app-sensitive-currency>
              </div>
            </div>

            <div class="row g-3 mb-3" *ngIf="hasDepositCard()">
              <ng-container *ngIf="depositPayments[0]?.method === 'CREDIT_CARD'">
                <div class="col-md-4">
                  <label class="form-label">Número do cartão</label>
                  <input type="text" class="form-control" [(ngModel)]="creditCardNumber" [ngModelOptions]="{ standalone: true }"
                    (input)="onCreditCardNumberInput($event, 1)" placeholder="0000 0000 0000 0000" maxlength="19">
                </div>
                <div class="col-md-4">
                  <label class="form-label">Nome no cartão</label>
                  <input type="text" class="form-control" [(ngModel)]="creditCardHolderName" [ngModelOptions]="{ standalone: true }">
                </div>
                <div class="col-md-2">
                  <label class="form-label">Mês</label>
                  <input type="text" class="form-control" [(ngModel)]="creditCardExpiryMonth" [ngModelOptions]="{ standalone: true }" maxlength="2" placeholder="MM">
                </div>
                <div class="col-md-2">
                  <label class="form-label">Ano</label>
                  <input type="text" class="form-control" [(ngModel)]="creditCardExpiryYear" [ngModelOptions]="{ standalone: true }" maxlength="4" placeholder="AAAA">
                </div>
                <div class="col-md-2">
                  <label class="form-label">CVV</label>
                  <input type="text" class="form-control" [(ngModel)]="creditCardCcv" [ngModelOptions]="{ standalone: true }" maxlength="4">
                </div>
                <div class="col-md-4">
                  <label class="form-label">Parcelas no cartão (método 1)</label>
                  <select class="form-select" [(ngModel)]="depositCardInstallments" [ngModelOptions]="{ standalone: true }">
                    <option [ngValue]="1">1x</option>
                    <option *ngFor="let n of [2,3,4,5,6,7,8,9,10]" [ngValue]="n">{{ n }}x</option>
                  </select>
                </div>
              </ng-container>
              <ng-container *ngIf="depositPayments[1]?.method === 'CREDIT_CARD'">
                <div class="col-md-4">
                  <label class="form-label">Número do cartão (2)</label>
                  <input type="text" class="form-control" [(ngModel)]="creditCardNumber2" [ngModelOptions]="{ standalone: true }"
                    (input)="onCreditCardNumberInput($event, 2)" placeholder="0000 0000 0000 0000" maxlength="19">
                </div>
                <div class="col-md-4">
                  <label class="form-label">Nome no cartão (2)</label>
                  <input type="text" class="form-control" [(ngModel)]="creditCardHolderName2" [ngModelOptions]="{ standalone: true }">
                </div>
                <div class="col-md-2">
                  <label class="form-label">Mês</label>
                  <input type="text" class="form-control" [(ngModel)]="creditCardExpiryMonth2" [ngModelOptions]="{ standalone: true }" maxlength="2">
                </div>
                <div class="col-md-2">
                  <label class="form-label">Ano</label>
                  <input type="text" class="form-control" [(ngModel)]="creditCardExpiryYear2" [ngModelOptions]="{ standalone: true }" maxlength="4">
                </div>
                <div class="col-md-2">
                  <label class="form-label">CVV</label>
                  <input type="text" class="form-control" [(ngModel)]="creditCardCcv2" [ngModelOptions]="{ standalone: true }" maxlength="4">
                </div>
                <div class="col-md-4">
                  <label class="form-label">Parcelas no cartão (método 2)</label>
                  <select class="form-select" [(ngModel)]="depositCardInstallments2" [ngModelOptions]="{ standalone: true }">
                    <option [ngValue]="1">1x</option>
                    <option *ngFor="let n of [2,3,4,5,6,7,8,9,10]" [ngValue]="n">{{ n }}x</option>
                  </select>
                </div>
              </ng-container>
            </div>

            <hr>
            <h5 class="mb-2">1ª parcela</h5>
            <div class="row g-3 mb-2">
              <div class="col-md-6">
                <label class="form-label">Quantidade de métodos</label>
                <select class="form-select" [(ngModel)]="firstInstallmentPaymentMode" (ngModelChange)="setFirstInstallmentPaymentMode($event)" [ngModelOptions]="{ standalone: true }">
                  <option [ngValue]="'single'">1 método</option>
                  <option [ngValue]="'split'">2 métodos</option>
                </select>
              </div>
            </div>
            <div class="row g-3 mb-2" *ngFor="let p of firstInstallmentPayments; let i = index" [hidden]="firstInstallmentPaymentMode === 'single' && i === 1">
              <div class="col-md-6">
                <label class="form-label">Método {{ i + 1 }}</label>
                <select class="form-select" [(ngModel)]="firstInstallmentPayments[i].method" [ngModelOptions]="{ standalone: true }">
                  <option *ngFor="let method of paymentMethods" [value]="method.value">{{ method.label }}</option>
                </select>
              </div>
              <div class="col-md-6">
                <label class="form-label">Valor</label>
                <app-sensitive-currency
                  [ngModel]="firstInstallmentPayments[i].amount ? firstInstallmentPayments[i].amount : null"
                  (ngModelChange)="onFirstInstallmentAmountChange(i, $event)"
                  [ngModelOptions]="{ standalone: true }"
                  [min]="0"
                  step="0.01"
                  [readonly]="firstInstallmentPaymentMode === 'single'">
                </app-sensitive-currency>
              </div>
            </div>

            <hr>
            <div class="d-flex justify-content-between align-items-center mt-3 mb-2">
              <h5 class="mb-0">Cobranças adicionais</h5>
              <button type="button" class="btn btn-sm btn-outline-primary" (click)="addExtraCharge()">
                <i class="fas fa-plus me-1"></i>
                Adicionar cobrança
              </button>
            </div>
            <p class="text-muted small mb-2">
              Selecione o tipo de cobrança (acessórios e serviços do contrato B2B).
            </p>
            <div class="extra-charge-card row g-2 mb-2" *ngFor="let charge of extraCharges; let idx = index">
              <div class="col-md-5">
                <label class="form-label">Tipo de cobrança</label>
                <select
                  class="form-select"
                  [(ngModel)]="extraCharges[idx].description"
                  [ngModelOptions]="{ standalone: true }">
                  <option value="">Selecione...</option>
                  <option *ngFor="let opt of additionalChargeTypeOptions" [value]="opt.value">
                    {{ opt.label }}
                  </option>
                </select>
              </div>
              <div class="col-md-3">
                <label class="form-label">Valor</label>
                <app-sensitive-currency
                  [(ngModel)]="extraCharges[idx].amount"
                  [ngModelOptions]="{ standalone: true }"
                  [min]="0"
                  step="0.01">
                </app-sensitive-currency>
              </div>
              <div class="col-md-3">
                <label class="form-label">Vencimento</label>
                <input
                  type="date"
                  class="form-control"
                  [(ngModel)]="extraCharges[idx].dueDate"
                  [ngModelOptions]="{ standalone: true }">
              </div>
              <div class="col-md-1 d-flex align-items-end">
                <button
                  type="button"
                  class="btn btn-outline-danger btn-sm w-100"
                  title="Remover cobrança"
                  (click)="removeExtraCharge(idx)"
                  [disabled]="extraCharges.length === 1">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Botões de ação -->
      <div class="form-actions">
        <button type="button" class="btn btn-secondary" (click)="navigateBack()" [disabled]="isSubmitting">
          Cancelar
        </button>
        <button *ngIf="currentStep === 1" type="button" class="btn btn-primary" (click)="goToStep(2)" [disabled]="isSubmitting">
          Próximo
        </button>
        <button *ngIf="currentStep === 2" type="button" class="btn btn-secondary" (click)="goToStep(1)" [disabled]="isSubmitting">
          Voltar
        </button>
        <button *ngIf="currentStep === 2" type="submit" class="btn btn-primary" [disabled]="itemForm.invalid || isSubmitting">
          <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2"></span>
          <i *ngIf="!isSubmitting" class="fas fa-save me-2"></i>
          {{ isSubmitting ? 'Salvando...' : 'Cadastrar Pedido' }}
        </button>
      </div>
    </form>
  </div>
</app-side-menu>
